export const api_url = 'https://dev.quecko.com/wp-json/wp/v2/'

export const BASE_URL = 'https://dev.quecko.com/wp-json/wp/v2'
                        // https://dev.quecko.com/wp-json/wp/v2/job?per_page=100
// export const SiteKey = '6LcaFB0rAAAAAPYMGuBaNZU0ynh_V6_eJq6R_rxB'
export const SiteKey = '6LdtWB8rAAAAAAP9QVAvrWYGyMuj2DygbxTupKKL'
// export const SECRETKEY = '6LcaFB0rAAAAAGrGZUv2Y-8cpxxhxcDxFA95spVr'
export const SECRETKEY = '6LdtWB8rAAAAAKWbFJQFkNK-QFJL7Y0kmVqaxDW-'
export const verifyUrlGoogle = 'https://www.google.com/recaptcha/api/siteverify'
export const bitFormResponseUrl = 'https://dev.quecko.com/wp-json/bitform/v1/entry/1'
export const BitFormheaders = '59971a5c6213ecbb4e58bf91b4a56962f05311d8'